import { render, staticRenderFns } from "./MatchResultModal.vue?vue&type=template&id=dafb4d04&"
import script from "./MatchResultModal.vue?vue&type=script&lang=js&"
export * from "./MatchResultModal.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports